var map = {
	".": "2KwY",
	"./": "2KwY",
	"./01_error_code": "+lFy",
	"./01_error_code.json": "+lFy",
	"./02_timestamp": "VQr5",
	"./02_timestamp.json": "VQr5",
	"./03_digital_rule": "C2jk",
	"./03_digital_rule.json": "C2jk",
	"./04_rate_limits": "nG30",
	"./04_rate_limits.json": "nG30",
	"./05_system_time": "zNUa",
	"./05_system_time.json": "zNUa",
	"./index": "2KwY",
	"./index.js": "2KwY",
	"./index_share_to_v1": "Vl00",
	"./index_share_to_v1.js": "Vl00"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GNIi";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/basic ^.*$
// module id = GNIi
// module chunks = 3